export default "__VITE_ASSET__Ed$trgqt__"